module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_ishikawa-a8a435caa31ff4b3e875b99d9834a986.png";